import React from 'react';

import Config from '@skin_config';
import CMSApi from '@app/dev/services/cmsApi';
import { useDataFetch } from '@common/hooks/dataFetch';

import { CasinoAdnLiveCasinoGame } from '@app/dev/terminal/components/casinoAndLiveCasinoViewer/components/game';
import HomeSectionTitle from '../sectionTitle';

import './style.scss';

const HomeCasinoGames = () => {
  const [data] = useDataFetch(() => (
    CMSApi.getCasinoGames({ limit: Config.verticalHome.casinoGamesCount || Config.home.casinoGamesCount })
  ), []);

  if (!data) return null;

  return (
    <div className="home-casino-games-wrp">
      <HomeSectionTitle title="Casino games" />

      <div className="home-casino-games">
        {data?.games?.map((game) => (
          <CasinoAdnLiveCasinoGame
            key={game.id}
            game={game}
          />
        ))}
      </div>
    </div>
  );
};

export default HomeCasinoGames;
